import { Injectable } from '@angular/core';
import { setFormDirtyStatus } from '@app/core/leave-page-handler/actions/leave-page';
import * as CalendarEditActions from '@app/pcs/actions/calendar-edit';
import {
  CalendarEditActionTypes,
  UpdateValidityPeriodFail,
  UpdateValidityPeriodSuccess
} from '@app/pcs/actions/calendar-edit';
import { Calendar } from '@app/pcs/models';
import { createCalendar } from '@app/pcs/models/calendar.schema';
import * as fromPcs from '@app/pcs/reducer';
import { CalendarEditService } from '@app/pcs/services/calendar-edit.service';
import { prepareCalendarToSave } from '@dossier/util/calendar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { mapPayload } from '@util';
import { exhaustMap, of } from 'rxjs';
import { catchError, switchMap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class CalendarEditEffects {

  private calendar$ = this.store.pipe(select(fromPcs.getCalendar));

  updateValidityPeriod$ = createEffect(() => this.actions$.pipe(
    ofType<CalendarEditActions.UpdateValidityPeriod>(CalendarEditActionTypes.UpdateValidityPeriod),
    mapPayload(),
    withLatestFrom(this.calendar$),
    exhaustMap(([{validityPeriod, existingPath}, templateCalendar]) =>
      this.calendarEditService.updateValidityPeriod(
        prepareCalendarToSave(templateCalendar), validityPeriod, existingPath
      ).pipe(
        switchMap((updatedCalendar: Calendar) =>
          of(new UpdateValidityPeriodSuccess(createCalendar(updatedCalendar)))),
        catchError(error => of(new UpdateValidityPeriodFail(error)))
      )
    )
  ));

  calendarEdit$ = createEffect(() => this.actions$.pipe(
    ofType<any>(
      CalendarEditActionTypes.SelectDay,
      CalendarEditActionTypes.SelectWeekDays,
      CalendarEditActionTypes.SelectMonth,
      CalendarEditActionTypes.SelectYear,
      CalendarEditActionTypes.SelectCalendarRange
    ),
    switchMap(() => of(setFormDirtyStatus()))
  ));

  constructor(private store: Store<fromPcs.State>,
    private actions$: Actions,
    private calendarEditService: CalendarEditService
  ) {
  }
}
